/**
 * Shared phone input with country code + flag dropdown.
 * Wraps `react-phone-number-input` and applies SouthTrip styling (cream-200 border, white bg).
 *
 *  Usage:
 *      <PhoneInputField
 *          value={phone}
 *          onChange={setPhone}
 *          required
 *          testId="cb-phone"
 *          defaultCountry="IN"
 *      />
 *
 *  The value emitted is in E.164 format (e.g. "+918075814740"). Backend can store as-is.
 */
import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

const PhoneInputField = ({
    value,
    onChange,
    required = false,
    testId = "phone-input",
    defaultCountry = "IN",
    className = "",
    placeholder = "Phone number",
}) => {
    return (
        <div
            className={
                "phone-input-wrapper mt-1 w-full rounded-lg border border-cream-200 bg-white focus-within:border-saffron-500 transition " +
                className
            }
            data-testid={`${testId}-wrapper`}
        >
            <PhoneInput
                international
                countryCallingCodeEditable={false}
                defaultCountry={defaultCountry}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                required={required}
                data-testid={testId}
                numberInputProps={{
                    "data-testid": testId,
                    className: "outline-none bg-transparent flex-1 text-sm px-2 py-2.5",
                }}
            />
        </div>
    );
};

export default PhoneInputField;
